import _ from "lodash";

// import set from "set-value";

interface EdgeInterface {
  source: string;
  target: string;
}
export function QuestDataFromPlumb(_data: { nodes: any[]; edges: EdgeInterface[] }) {
  var nodes: any = {};

  try {
    const data = JSON.parse(JSON.stringify(_data));
    var sources: any = [];

    for (const key in data.nodes) {
      if (Object.prototype.hasOwnProperty.call(data.nodes, key)) {
        let node = data.nodes[key];

        nodes[node.id] = node;
        if (node.layout?.sources) {
          sources.push(...node.layout.sources);
        }

        delete node.layout;
      }
    }

    var edgeSources: string[] = [];
    data.edges.forEach((edge: any) => {
      // const source = get(nodes, edge.source) // nodes[edge.source];
      // if (source) {
      //
      // } else {
      //
      //     return;
      // }

      edgeSources.push(edge.source);

      _.set(nodes, edge.source.replace(/_/g, "."), edge.target.split(".")[0]);
    });

    const notSetEdges = _.difference(sources, edgeSources);
    notSetEdges.forEach((edge) => {
      _.set(nodes, edge.replace(/_/g, "."), undefined);
    });

    return nodes;
  } catch (e) {
    return nodes;
  }
}
